module.exports = __webpack_public_path__ + "img/av003.2ba5b6df.png";